import React from 'react';
import shortid from 'shortid';
import Typography from '@material-ui/core/Typography';
import { Alert, AlertTitle } from '@material-ui/lab';

function translate(text) {
  const trans = {
    'username': 'Nombre de usuario',
    'password': 'Contraseña',
    'email': 'E-Mail',
    'login failed': 'Falló inicio de sesión',
    'the account is not activated': 'La cuenta no esta activada',
    'you are not authorized to obtain this resource': 'No está autorizado para obtener este recurso',
    'the account does not exist': 'La cuenta no existe',
    'username must only contain letters, numbers, dots and underscore. excluding the points at the beginning and end': 'Sólo puede contener puntos, guión bajos, letras y números. Excluyendo los puntos al inicio y final',
    'username should not be null or undefined': 'El nombre de usuario no debe ser null o undefined',
    'username must be longer than or equal to 0 characters': 'Nombre de usuario debe tener 0 o más caracteres',
    'username must be shorter than or equal to 30 characters': 'El nombre de usuario debe tener 30 o menos caracteres',
    'the username is already used': 'El nombre de usuario ya está en uso',
    'password must be shorter than or equal to 255 characters': 'La contraseña debe tener 255 o menos caracteres',
    'password should not be null or undefined': 'La contraseña no debe ser null o undefined',
    'the password is required': 'La contraseña es requerida',
    'password must conatin uppercase': 'La contraseña debe contener mayúsculas',
    'password must contain lowercase': 'La contraseña debe contener minúsculas',
    'password must contain number': 'La contraseña debe contener un número',
    'password must contain special characters': 'La contraseña debe contener caracteres especiales',
    'password must be longer than or equal to 0 characters': 'Contraseña debe tener 0 o más caracteres',
    'email must be shorter than or equal to 255 characters': 'El E-Mail debe tener 255 o menos caracteres',
    'the email is already used': 'El E-Mail ya está en uso',
    'email must be an email': 'Debe respetar el formato',
    'email should not be null or undefined': 'El E-Mail no debe ser null o undefined',
    'email must be longer than or equal to 0 characters': 'El E-Mail debe tener 0 o más caracteres',
    'invalid code': 'Código incorrecto',
    'code used': 'Código usado',
  }
  return trans[text] ? trans[text] : text;
}

const AlertGlobalErrors = (props) => {
    const {
        errors 
    } = props;

    if(!errors || errors.length < 0) {
      return null;
    }

    let contenido = errors.map(error => {
        if(error.type === 'body') {
          return (
            <React.Fragment key={shortid.generate()}>
              <AlertTitle>{translate(error.property)}</AlertTitle>
              {
                error.messages.map((message) => {
                  return (
                    <Typography key={shortid.generate()} component="p">
                    - {translate(message)}
                    </Typography>
                  );
                })
              }
            </React.Fragment>  
          );
        } else {
          return (
            <React.Fragment key={shortid.generate()}>
              <AlertTitle >{error.title}</AlertTitle>
              <Typography component="p">
                - {translate(error.message)}
              </Typography>
            </React.Fragment>  
          );
        }
      });

    return (
      <Alert severity="error">
        {
          contenido
        }
      </Alert>
    )
  }

export default AlertGlobalErrors;